import React from "react";
import "/src/assets/scss/components/heros.scss";

function HeroProducts() {
  return (
    <div className="hero hero-products">
      <h1 className="title-1">OUR PRODUCTS</h1>
    </div>
  );
}

export default HeroProducts;
